<template>
  <div
    v-if="show"
    ref="content"
    class="AddOnList"
  >
    <div class="bread">
      <span
        v-if="tabChannelId == 2"
        class="link"
        @click="toShopHome()"
      >{{ TLang('优选生活','my') }}</span>
      <span
        v-if="tabChannelId == 998 || tabChannelId == 18"
        class="link"
        @click="toShopBook()"
      >{{ TLang('图书','my') }}</span>
      <span
        v-if="tabChannelId == 999"
        class="link"
        @click="toShopJD()"
      >{{ TLang('京东优选','my') }}</span>
      <span
        v-if="tabChannelId == 20"
        class="link"
        @click="toShopXM()"
      >{{ TLang('小米有品','my') }}</span>
      <span
        v-if="tabChannelId == 22"
        class="link"
        @click="toShopWY()"
      >{{ TLang('网易严选','my') }}</span>
      <span
        v-if="tabChannelId == 17"
        class="link"
        @click="toShopCS()"
      >{{ TLang('东福超市','my') }}</span>
      <img
        src="@/assets/images/arrow.png"
        alt=""
        class="arrow"
      />
      <span
        class="link"
        @click="toUserCart()"
      >{{ TLang('购物车','my') }}</span>
      <img
        src="@/assets/images/arrow.png"
        alt=""
        class="arrow"
      />
      <span>{{ TLang('凑单商品','my') }}</span>
    </div>
    <SelectBar
      :catList="catList"
      :onCateChange="onCateChange"
      :chooseAll="chooseAll"
      :selectType="'add'"
      :channelCode="Number(longParams.channelId)"
      :showSelected="false"
    />
    <div class="search">
      <div class="search-price">
        <p
          :class="[longParams.sortField == '1' && 'active']"
          @click="checkoutSortField('1')"
        >
          {{ TLang('综合','list') }}
        </p>
        <p
          :class="[longParams.sortField == '2' && 'active']"
          @click="checkoutSortField('2')"
        >
          {{ TLang('销量','list') }}
        </p>
        <p
          :class="[longParams.sortField == '3' && 'active']"
          @click="checkoutSortField('3')"
        >
          {{ TLang('新品','list') }}
        </p>
        <p
          :class="['price', longParams.sortField == '4' && 'active']"
          @click="onSortTypeChange((!longParams.sortType || longParams.sortType == 1) ? 2 : 1)"
        >
          {{ TLang('价格','my') }}
          <i
            :class="['up', longParams.sortType === 2 && 'active']"
          ></i>
          <i
            :class="['down', longParams.sortType === 1 && 'active']"
          ></i>
        </p>
        <!-- 英文 -->
        <div v-if="CookiesOne==='en-US'">
          <input
            v-model="longParams.lowerPriceLimit"
            type="number"
            placeholder="Min.price"
          />
          <span>-</span>
          <input
            v-model="longParams.priceCap"
            type="number"
            placeholder="Max.price"
          />
        </div>
        <!-- 中文 -->
        <div v-if="CookiesOne!=='en-US'">
          <input
            v-model="longParams.lowerPriceLimit"
            type="number"
            placeholder="最低价"
          />
          <span>-</span>
          <input
            v-model="longParams.priceCap"
            type="number"
            placeholder="最高价"
          />
        </div>
        <div class="flex confirm-btns">
          <span
            @click="confirmPrice"
          >{{ TLang('确定','my') }}</span>
          <div @click="canclePrice">
            {{ TLang('取消','my') }}
          </div>
        </div>
        <div class="searchWrap">
          <input
            v-model="words"
            type="text"
            class="keyword-input"
          />
          <div
            class="search-btn"
            @click="confirmSearch"
          >
            {{ TLang('搜索','my') }}
          </div>
        </div>
      </div>
    </div>
    <div class="goods-wrap">
      <ul>
        <li
          v-for="(goods, index) in goodsList"
          :key="index"
        >
          <Goods
            :goods="goods"
            :onClick="toDetailAndMemory.bind(this, goods)"
            :onClickAdd="onClickAdd.bind(this, goods)"
          />
          <span v-if="successToastId === goods.goodsId">{{ TLang('加入购物车成功','my') }}</span>
        </li>
      </ul>
      <Empty
        v-if="isEmpty"
        :topre="topre"
        :path="'add'"
      />
    </div>
    <div
      v-if="goodsList.length && total > 20"
      class="Pagination"
    >
      <Pagination
        :current-page.sync="longParams.pageNumber * 1"
        :page-size="20"
        layout="prev, pager, next, total, jumper"
        :total="total"
        background
        @current-change="handleCurrentChange"
      ></Pagination>
    </div>
    <div :class="['differAmount', isSticky && 'fixed']">
      <span v-if="differAmount && Number(weightInfo.freeWeight) === 0">{{ TLang('还差','my') }}<span :style="{ color: '#f00' }">{{
        parseFloat((differAmount * union_scale)).toFixed(2)
      }}</span>{{ union_name || TLang('福豆', 'card') }}{{ TLang('包邮','my') }}</span>
      <span
        v-else-if="Number(weightInfo.freeWeight) === 0"
        :style="{ color: '#333333', fontSize: '15px' }"
      >{{ TLang('已达到包邮金额','my') }}</span>
      <div
        v-else-if="+weightInfo.showType === 1"
        :style="{display: 'flex', flexDirection: 'column', justifyContent: 'center'}"
      >
        <div :style="{color: '#333333', fontSize: '15px', textAlign: 'right', lineHeight: 'initial'}">
          {{ TLang('已达到包邮金额','my') }}
        </div>
        <div
          v-show="Number(weightInfo.currentWeight) > 0 && Number(weightInfo.freeWeight) > 0"
          :style="{color: '#B2B2B2', fontSize: '12px', lineHeight: 'initial'}"
        >
          {{ TLang('当前重量','my') }}{{ weightInfo.currentWeight }}kg {{ ReplaceText('X', weightInfo.freeWeight, TLang('内包邮','my')) }}
        </div>
      </div>
      <div
        v-else-if="+weightInfo.showType === 2"
        :style="{display: 'flex', flexDirection: 'column', justifyContent: 'center'}"
      >
        <div :style="{color: '#333333', fontSize: '15px', textAlign: 'right', lineHeight: 'initial'}">
          {{ TLang('还差','my') }}<span :style="{color: '#F44545'}">{{ parseFloat((differAmount || '') * union_scale).toFixed(2) }}</span>{{
            union_name || TLang('福豆', 'my') }}{{ TLang('包邮','my') }}{{ weightInfo.freeWeight ? `(${ReplaceText('XX', weightInfo.freeWeight, TLang('kg内','my'))})` : '' }}
        </div>
        <div
          v-if="Number(weightInfo.currentWeight) > 0 && Number(weightInfo.postage) > 0"
          :style="{color: '#B2B2B2', fontSize: '12px', lineHeight: 'initial'}"
        >
          {{ TLang('当前重量','my') }}{{ weightInfo.currentWeight }}kg
        </div>
      </div>
      <div
        v-else-if="+weightInfo.showType === 3"
        :style="{display: 'flex', flexDirection: 'column', justifyContent: 'center'}"
      >
        <div :style="{color: '#333333', fontSize: '15px', textAlign: 'right', lineHeight: 'initial'}">
          {{ TLang('需支付运费','my') }}{{ Number(weightInfo.freeWeight) > 0 ? `(${ReplaceText('X', weightInfo.freeWeight, TLang('内包邮','my'))})` : '' }}
        </div>
        <div
          v-if="Number(weightInfo.currentWeight) > 0"
          :style="{color: '#B2B2B2', fontSize: '12px', lineHeight: 'initial'}"
        >
          {{ TLang('当前重量','my') }}{{ weightInfo.currentWeight }}kg {{ ReplaceText('XX', parseFloat(((weightInfo.postage || '') * union_scale).toFixed(2)), ReplaceText('UU', union_name || TLang('福豆', 'my'), TLang('超重','my'))) }}
        </div>
      </div>
      <div v-else></div>
      <a href="/shop/shopping/cart">{{ TLang('去购物车','my') }}</a>
    </div>
    <SkuPicker
      :visible="SkuPickerShow"
      :goods="activeGoods"
      :onClose="
        () => {
          this.SkuPickerShow = false;
        }
      "
      :onAdd="onClickSkuAdd"
    />
    <Dialog
      title=" "
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="product-dialog"
      center
      top="50vh"
      :lock-scroll="false"
      @open="dialogVisible = true"
    >
      <img
        :src="require('@assets/images/successIcon.svg')"
        style="width: 55px;height: 36px;"
      />
      <div class="title">
        {{ TLang('加入购物车成功','my') }}
      </div>
      <!-- <div class="goods-name">
        {{ chooseOfAdd.goodsName }}
      </div>
      <div class="goods-sku-name">
        规格：{{ chooseOfAdd.specValue1 || chooseOfAdd.specName }}
      </div> -->
      <div class="btns">
        <button
          class="close-btn"
          @click="toDetail(chooseOfAdd)"
        >
          {{ TLang('查看商品详情','my') }}
        </button>
        <button
          class="buy-btn primary"
          @click="toUserCart()"
        >
          {{ TLang('去结算','my') }}
        </button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import SelectBar from "./../product/list/SelectBar";
import AddressRow from "./../product/detail/AddressRow";
import Empty from "./../product/list/Empty";
import Goods from "./../lifeIndex/GoodsItem";
import { Pagination } from "element-ui";
import { fetchAddList, fetchGoodsTags } from "@fetch";
import { getQueryString } from "@utils";
import { dealTagGoods } from '@/utils/special';
import Cookies from "js-cookie";
import Toast from "@components/simpleToast";
import SkuPicker from "@components/SkuPicker";
import { Dialog } from "element-ui";
import { queryFreight, fetchaddCart, fetchSkuBySpuId, getActivityTag } from "@fetch/shopping";
import { healthChannelId } from "@utils/config";
export default {
  name: "AddOnList",
  components: {
    SelectBar,
    AddressRow,
    Empty,
    Goods,
    Pagination,
    SkuPicker,
    Dialog,
  },
  data() {
    return {
      tabChannelId: Number(getQueryString("channelId")) || null,
      show: false,
      activeGoods: {},
      SkuPickerShow: false,
      dialogVisible: false,
      chooseOfAdd: {},
      catList: [],
      addressInfo: Cookies.get("address") && JSON.parse(Cookies.get("address")),
      goodsList: [],
      isEmpty: false,
      total: 0,
      differAmount: 0,
      weightInfo: {},
      longParams: {
        sourceType: 1, // 1从购物车带来的分类参数 2切换凑单页选项时的分类参数
        lowerPriceLimit: null,
        priceCap: null,
        sortType: null,
        sortField: 1,
        categoryIdList:
          JSON.parse(window.localStorage.getItem("categoryIdList")) || [],
        cartCategoryIdList: JSON.parse(window.localStorage.getItem("categoryIdList")) || [],
        channelId: Number(getQueryString("channelId")) || null,
        channels:Number(getQueryString("channelId")) ? [Number(getQueryString("channelId"))] : null,
        pageNumber: 1,
        pageSize: 20,
        goodsType: 0,
        // isCollectBills: Number(getQueryString("channelId")) === 17 ? false : true,
        isCollectBills: getQueryString('merchantType') == 2 ? false : true,
        merchantId: getQueryString("mId") || null,
        provinceId: JSON.parse(Cookies.get("address") || '{}').provinceId || null,
        regionId: JSON.parse(Cookies.get("address") || '{}').regionId || null,
        streetId: JSON.parse(Cookies.get("address") || '{}').streetId || null,
        wordsName: '',
      },
      merchantType: getQueryString('merchantType'),
      isSticky: false,
      successToastId: null,
      healthChannelId: healthChannelId,
      singleSpecFlag: false, // 加购商品是否为单规格
      CookiesOne:Cookies.get('df_lang'),
      words: '',
      freshenPrice: true, // 是否刷新价格区间 false 不刷新 true 刷新为全部价格 默认全部价格
      firstMinPrice: getQueryString('price') ? Math.ceil(Number(getQueryString('price'))) : null,
      firstMaxPrice: getQueryString('price') ? Math.ceil(Number(getQueryString('price')) + 20) : null,
    };
  },
  computed: {
    getGoodTagsParams() {
      const goodsList = [];
      this.goodsList.forEach((good) => {
        if (good.categoryId)
          goodsList.push({
            categoryId: good.categoryId,
            goodsId: good.goodsId,
          });
      });
      return goodsList;
    },
  },
  mounted() {
    setTimeout(() => {
      this.handleScroll();
    }, 300);
    window.addEventListener("scroll", this.handleScroll, false);
    this.init(1);
  },
  unmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    init(enterNum) {
      let fetchListParams = { ...this.longParams };
      if (enterNum == 1 && (this.firstMinPrice || this.firstMaxPrice)) {
        fetchListParams.lowerPriceLimit = this.firstMinPrice;
        fetchListParams.priceCap = this.firstMaxPrice;
        // 首次请求，表示从购物车来
        fetchListParams.isCartCome = true;
      }
      fetchAddList(fetchListParams).then((res) => {
        this.show = true;
        this.tabChannelId = res.channelCode || 2;
        document.title = this.TLang('凑单页', 'my');

        // freshenPrice false表示该价格区间有结果，可用
        if(!res.freshenPrice) {
          this.freshenPrice = res.freshenPrice;
          // 若首次进入，差价区间返回结果有值，则将价格区间赋值到longParams
          if (enterNum == 1) {
            this.longParams = {...this.longParams, lowerPriceLimit: this.firstMinPrice, priceCap: this.firstMaxPrice};
          }
        } else {
          this.firstMaxPrice = null;
          this.firstMinPrice = null;
          if (enterNum == 1) {
            this.longParams = {...this.longParams, lowerPriceLimit: null, priceCap: null};
          }
        }
        // 分类列表集合
        let firstArr = [];
        let channleArr = [];
        let Obj = res.categoryDtos;
        for(var key in Obj) {
          firstArr = firstArr.concat(Obj[key]);
          channleArr.push(key);
        }
        this.catList = firstArr || [];
        this.longParams.channels = channleArr && channleArr.length > 0 ? channleArr : null;
        this.goodsList =
          (res.categoryGoodsDtos &&
            res.categoryGoodsDtos.categoryGoodsDtoList) ||
          [];
        this.getGoodsTags();
        this.total = res.count;
        if (this.catList && this.catList.length > 0) {
          this.catList.map((first) => {
            //点击全部 拿上一级「父」id
            //点击全部 拿上一级「父」id
            if (first) {
              if (first.subCategoryList) {
                first.subCategoryList = [
                  { name: this.TLang('全部', 'my'), father: first && first.name, id: first && first.id }
                ].concat(first.subCategoryList);
              } else {
                first.subCategoryList = [
                  { name: this.TLang('全部', 'my'), father: first && first.name, id: first && first.id }
                ];
              }
            }
          });
        }
        setTimeout(() => {
          this.isEmpty =
            res.categoryGoodsDtos === null ||
            !res.categoryGoodsDtos.categoryGoodsDtoList.length;
        }, 300);
      });
      queryFreight({
        merchantId: getQueryString("mId"),
        channelId: Number(getQueryString("channelId")) || null,
        ...this.addressInfo,
      }).then((body) => {
        this.differAmount = body.differAmount;
        this.weightInfo = body || {};
      });
    },
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (
        this.$refs.content && this.$refs.content.getBoundingClientRect().bottom +
          Number(this.isSticky) * 74 +
          74 <=
        window.screen.availHeight
      ) {
        this.isSticky = false;
      } else {
        this.isSticky = true;
      }
    },
    onCateChange(idList, currentFirstId) {
      this.longParams.pageNumber = 1;
      this.longParams.sourceType = 2;
      this.longParams.categoryIdList = [];
      // console.log(idList)
      this.longParams.categoryIdList.push(idList && idList.id);
      this.init();
    },
    chooseAll() {
      this.longParams.sourceType = 2;
      this.longParams.categoryIdList = [null];
      this.$router.push({
        path: "/add/list",
        query: {
          ...this.$route.query,
          // categoryId: null,
          // bn: brand.name,
          // keyword: null,
        },
      });
      this.init();
    },
    onAddressChange(address) {
      if (address) {
        Cookies.set("address", address, { expires: 365 });
        console.log("Cookies.set3", address);
        this.addressInfo = address;
        this.longParams = {
          ...this.longParams,
          provinceId: address.provinceId,
          cityId: address.cityId,
          regionId: address.regionId,
          streetId: address.streetId,
        };
        this.init();
      }
    },
    toDetailAndMemory(goods) {
      window.open(`/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,
        this.isFeishuOrDingding ? '_self' : '_blank',
      );
      // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
    },
    topre() {
      window.history.go(-1);
    },
    onClickAdd(goods) {
      fetchSkuBySpuId({
        categoryId: goods.categoryId,
        spuId: goods.mallSpuId,
      }).then((body) => {
        if (body && body.length) {
          if (body.length === 1) {
            const myChoose = {
              categoryId: body[0].categoryId,
              goodsId: body[0].goodsId,
              num: body[0].buyMin || 1,
            };
            this.singleSpecFlag = true;
            this.onClickSkuAdd(myChoose, { goods });
            return;
          }
          try {
            let checkList = [];
            body && body.length > 0 && body.forEach(item => {
              item.tags = [];
              if (item.categoryId && item.goodsId) {
                checkList.push({
                  categoryId: item.categoryId,
                  goodsId: item.goodsId,
                });
              }
            });
            checkList && checkList.length > 0 && getActivityTag({
              channel: 2,
              goodsList: checkList,
            }).then((res) => {
              if (res && res.length > 0){
                body && body.length > 0 && body.forEach(item => {
                  item = dealTagGoods(item, res);
                });
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
                this.singleSpecFlag = false;
              } else {
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
                this.singleSpecFlag = false;
              }
            });
          } catch (error) {
            this.activeGoods = goods;
            this.activeGoods.goodsSpecList = body;
            this.SkuPickerShow = true;
            this.singleSpecFlag = false;
          }
        }
      });
    },
    onClickSkuAdd(myChoose, g) {
      this.chooseOfAdd = { ...myChoose, ...g };
      let timer = null;
      fetchaddCart({
        categoryId: g.goods.categoryId,
        goodsId: myChoose.goodsId,
        goodsNum: myChoose.num,
        ...this.addressInfo,
      }).then((body) => {
        if (body === "成功") {
          if (this.singleSpecFlag) {
            this.dialogVisible = true;
          } else {
            this.successToastId = myChoose.goodsId;
            timer = setTimeout(() => {
              this.successToastId = null;
              clearTimeout(timer);
            }, 2000);
          }
          queryFreight({
            merchantId: getQueryString("mId"),
            channelId: Number(getQueryString("channelId")) || null,
            ...this.addressInfo,
          }).then((body) => {
            this.differAmount = body.differAmount;
            this.weightInfo = body || {};
          });
        } else {
          Toast.info(body.msg, 1);
        }
      });
      this.SkuPickerShow = false;
    },
    handleCurrentChange(page) {
      this.longParams = { ...this.longParams, pageNumber: page };
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.init();
    },
    checkoutSortField(sortField) {
      this.longParams.sortField = sortField;
      this.longParams.sortType = null;
      this.longParams.pageNumber = 1;
      this.init();
      // this.onSortFieldChange(sortField);
      // this.sendFilterGio('排序',moduleNames['name'+sortField])
    },
    onSortTypeChange(type) {
      // debugger;
      this.longParams = { ...this.longParams, sortField: 4, sortType: type, pageNumber: 1 };
      this.init();
    },
    confirmSearch() {
      this.longParams = { ...this.longParams, pageNumber: 1, wordsName: this.words };
      this.init();
    },
    confirmPrice() {
      this.longParams = { ...this.longParams, pageNumber: 1 };
      this.init();
    },
    canclePrice() {
      this.longParams = {
        ...this.longParams,
        lowerPriceLimit: null,
        priceCap: null,
      };
      this.longParams.lowerPriceLimit = null;
      this.longParams.priceCap = null;
      this.init();
    },
    toDetail(goods) {
      window.open(`/shop/product/detail?cid=${goods.goods.categoryId}&gid=${goods.goodsId}`,
        this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = `/shop/product/detail?cid=${goods.goods.categoryId}&gid=${goods.goodsId}`;
    },
    toShopHome() {
      window.open(`/shop/home`,this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = `/shop/home`;
    },
    toShopBook() {
      window.open(`/book`, this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = `/book`;
    },
    toShopJD() {
      window.open("/shopHome/?channelId=999",this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = "/shopHome/?channelId=999";
    },
    toShopXM() {
      window.open("/xmlifepc/",this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = "/xmlifepc/";
    },
    toShopWY() {
      window.open("/wylife/",this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = "/wylife/";
    },
    toShopCS() {
      window.open("/chaoshi",this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = "/chaoshi";
    },
    toUserCart() {
      window.open(`/shop/shopping/cart`,this.isFeishuOrDingding ? '_self' : '_blank');
      // window.location.href = `/shop/shopping/cart`;
    },
    // 商品数据拼接tag
    goodsListAddFlag(res) {
      this.goodsList.forEach((good) => {
        const goodTag = res.find(
          (tag) =>
            tag.categoryId == good.categoryId && tag.goodsId == good.goodsId,
        ) || {};
        let tags = goodTag && goodTag.tags ? goodTag.tags : [];
        // 凑单页标签
        //type  1特价抢购   满减     2爆炸贴       3新品
        let newTags = tags.filter((item) => item.type !=2);
        let stickerImgList = tags.filter((item) => item.type === 2);
        const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
        const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
        const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
        this.$set(good, "tags", newTags);
        this.$set(good, "promPrice", promPrice);
        this.$set(good, "salePrice", salePrice);
        this.$set(good, "bizStock", bizStock);
        // 爆炸贴数据
        this.$set(good, "stickerImgList", stickerImgList);
        // 拼接折扣信息
        this.$set(good, "discount", goodTag.discount);
        this.$set(good, "discountPrice", goodTag.discountPrice);
        this.$set(good, "discountTagShow", goodTag.discountTagShow);
        this.$set(good, "mktTagShow", goodTag.mktTagShow);
        this.$set(good, 'dfPriceVo', goodTag.dfPriceVo);

        // 福拼拼相关字段
        // Y 为福拼拼
        this.$set(good,"groupItem", goodTag.groupItem);
        // groupItemClassStyle 样式 1、文本模式，2、+货币模式
        this.$set(good,"groupItemClassStyle", goodTag.groupItemClassStyle);
        // 拼团价格
        this.$set(good,"groupItemPrice", goodTag.groupItemPrice);
        // 拼团价格限制 最高可抵扣福豆
        this.$set(good,"groupItemPriceLimit", goodTag.groupItemPriceLimit);
        // 拼团商品是否显示人命币 Y:是 N:否
        this.$set(good,"groupItemShowRmbSymbol", goodTag.groupItemShowRmbSymbol );
      });
    },
    // 获取商品tag
    getGoodsTags() {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              this.goodsListAddFlag(res);
            }
          },
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.AddOnList {
  .bread {
    line-height: 48px;
    font-size: 14px;
    color: #666;
    display: flex;
    align-items: center;
    span.link {
      cursor: pointer;
    }
    .arrow {
      width: 16px;
      height: 16px;
      margin: 0 5px;
    }
  }
  .search {
    display: flex;
    align-items: center;
    height: 48px;
    background: rgba(247, 247, 247, 1);
    border: 1px solid rgba(229, 229, 229, 1);
    margin-top: 24px;
    // padding: 0 16px;
    .search-price {
      display: flex;
      align-items: center;
      width: 100%;
      .confirm-btns {
        margin-left: 12px;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        span {
          width: 50px;
          height: 24px;
          background: #3FA6FF;
          background: var(--df-primary-color, #3FA6FF);
          color: #fff;
          border-radius: 2px;
        }
        div {
          width: 50px;
          height: 22px;
          background: #fff;
          color: #999999;
          border-radius: 2px;
          border: 1px solid rgba(224, 230, 237, 1);
          margin-left: 10px;
          line-height: 22px;
        }
        &:hover {
          cursor: pointer;
        }
        .close-btn {
          width: auto;
          min-width: 120px;
        }
      }
      p {
        width: 64px;
        text-align: center;
        color: #333333;
        height: 48px;
        line-height: 48px;
      }
      p.active {
        background: #fff;
        color: var(--df-primary-color, #3FA6FF);
      }
      .price {
        position: relative;
        margin-right: 12px;
        padding-right: 12px;
        i {
          position: absolute;
          border: 5px solid transparent;
          right: 19px;
          // top: 0;
        }
        .up {
          border-bottom-color: #999999;
          top: 14px;
        }
        .down {
          border-bottom-color: #999999;
          top: 25px;
          transform: rotate(180deg);
        }
        i.active {
          border-bottom-color: var(--df-primary-color, #3FA6FF);
        }
      }
      .searchWrap {
        margin-left: auto;
        display: flex;
        align-items: center;
        float: right;
        .search-btn {
          width: 44px;
          height: 28px;
          border: 1px solid rgba(229, 229, 229, 1);
          color: #111;
          text-align: center;
          line-height: 28px;
          margin-left: 5px;
          margin-right: 24px;
          &:hover {
            cursor: pointer;
          }
        }
        .count {
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          margin-right: 24px;
        }
      }
    }
    .search-address {
      height: 100%;
      /deep/ .address-content {
        ul {
          max-height: 186px !important;
        }
      }
      .address-pick {
        margin-top: 9px;
      }
      .address_line {
        /deep/ .chooseAddress {
          right: -1px;
          left: auto;
        }
        /deep/ .address-pick .product-address .stock {
          margin-left: 0;
        }
      }
    }
    /deep/ .drop-down {
      background: #fff;
      max-width: 335px;
      height: 28px;
      line-height: 28px;
    }
    input[type="number"] {
      width: 64px;
      outline: none;
      &:focus {
        border: 1px solid #3FA6FF;
        border: 1px solid var(--df-primary-color, #3FA6FF);
      }
    }
    input[type="text"] {
      width: 130px;
      height: 28px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .goods-wrap {
    min-height: 330px;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        margin-right: 12px;
        margin-bottom: 10px;
        padding: 30px 0;
        min-height: 282px;
        box-sizing: border-box;
        position: relative;
        &:nth-child(5n) {
          margin-right: 0;
        }
        /deep/ .GoodsItem {
          width: 200px;
          padding: 15px;
        }
        /deep/ .discountPriceWrap {
          padding: 0;
        }
        /deep/ .line-price-box {
          margin: 0;
        }
        /deep/ .fpp-style{
          padding: 0 !important;
        }
        /deep/ .imgBox {
          margin: 0;
        }
        /deep/ .goods-name {
          padding: 0;
        }
        /deep/ .row-price {
          padding: 0;
        }
        /deep/.goods-flag{
          padding: 5px 0 0;
        }
      }
      span {
        position: absolute;
        top: 32%;
        width: 100%;
        text-align: center;
        height: 50px;
        border-radius: 4px;
        line-height: 50px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        font-weight: 500;
      }
    }
  }
  .Pagination {
    height: 50px;
    /deep/ .el-pagination {
      float: right;
      margin-bottom: 20px;
    }
  }
  .differAmount {
    display: flex;
    height: 72px;
    border: 1px solid rgba(229, 229, 229, 1);
    line-height: 72px;
    width: 1200px;
    background: #fff;
    justify-content: flex-end;
    color: rgba(51, 51, 51, 1);
    a {
      font-size: 20px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      width: 180px;
      background: #3FA6FF;
      background: var(--df-primary-color, #3FA6FF);
      text-align: center;
      margin-left: 20px;
    }
  }
  .fixed {
    position: fixed;
    bottom: 0;
  }
}
</style>>
